import { render } from "./ConfigPanel.vue?vue&type=template&id=9d3f1b5e"
import script from "./ConfigPanel.vue?vue&type=script&lang=js"
export * from "./ConfigPanel.vue?vue&type=script&lang=js"

import "./ConfigPanel.vue?vue&type=style&index=0&id=9d3f1b5e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__